import { Drawer, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import MessageDetails from "./MessageDetails";
import { handleSetMessageDetailsFilter } from "../../ClientSideStates";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";

const MobileMessageDrawer = () => {
    const { messageDetilsFilter, } = useSelector(
        (state: RootState) => state.message
      );
      const dispatch= useDispatch()
      const {Text} = Typography
    const onCloseDrawer=()=>{
      const curentFilter = {...messageDetilsFilter}
      delete curentFilter["ContactUserId"]
      delete curentFilter["AdvertId"]
       dispatch(handleSetMessageDetailsFilter({ filter: curentFilter }));

    }
    return (<>
     <Drawer
     className="!block xl:!hidden"
      open={messageDetilsFilter?.ContactUserId && messageDetilsFilter.AdvertId}
      width={"100%"}
      mask={false}
      closeIcon={<ArrowLeftOutlined/>}
    
      onClose={onCloseDrawer}
      title={<Text onClick={onCloseDrawer} className="!text-xs md:!text-sm" >Geriye Dön</Text>}
      >
        <MessageDetails/>
      </Drawer>
    
    </>  );
}
 
export default MobileMessageDrawer;